export default newAccordionSection => {
  const filters = newAccordionSection.section.querySelectorAll(
    'input[name="appliedFilter"][checked="checked"]'
  );

  if (filters.length) {
    newAccordionSection.isExpandedByDefault = true;
  }
}